export function parseMoney(s: string): number {
    const n = Number.parseFloat(s);
    return Number.isFinite(n) ? n : 0;
}

export function formatBrl(amount: number): string {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(amount);
}
